export default "https://cdn.questicon.mathletics.com/assets/images/command-fac83732018bd5d45153722ebbbc92b4.svg";